import { useSelector } from 'react-redux'

import { RootState } from 'types'
import { useCurrentArticleId } from './useCurrentArticleId'

export const useCurrentArticleMeta = () => {
  const articleId = useCurrentArticleId()
  return useSelector(({ articleMeta }: RootState) => (articleId ? articleMeta[articleId] : null))
}
